module.exports = __webpack_public_path__ + "static/media/design7.07c509c3.png";